import { AlertsData } from "../../../utils/apis/reports_repository";
import { Text } from "../Text";
import { getDateTime } from "../../../utils/helper";

interface AlertDetailsProps {
    alert: AlertsData;
}

export const AlertDetails = ({ alert }: AlertDetailsProps) => {
    return (
        <div className="overflow-y-auto pr-2 pb-8">
            {/* Summary grid */}
            <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
                {/* Alert Type + Repeat Offender */}
                <div>
                    <Text as="h3">Alert Type</Text>
                    <div className="w-fit mt-1 bg-primary py-2 px-4 flex justify-center text-white text-sm rounded-md">
                        {alert.alertType}
                    </div>
                </div>
                <div>
                    <Text as="h3">Status</Text>
                    <div className={`w-fit mt-1 py-2 px-4 flex justify-center rounded-md text-sm ${alert.acknowledged ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                        {alert.acknowledged ? "Acknowledged" : "Unacknowledged"}
                    </div>
                </div>

                {/* Entry Time + Alert Time */}
                <div>
                    <Text as="h3">Vehicle Entry Time</Text>
                    <Text className="text-secondaryText mt-1">{getDateTime(alert.entryTimestamp)}</Text>
                </div>
                <div>
                    <Text as="h3">Alert Timestamp</Text>
                    <Text className="text-secondaryText mt-1">{getDateTime(alert.alertTimestamp)}</Text>
                </div>

                {/* Vehicle Plate + Repeat Offender */}
                <div>
                    <Text as="h3">Vehicle Plate</Text>
                    <div className="flex flex-wrap gap-2 mt-1">
                        <span className="bg-gray-100 text-gray-700 px-3 py-1 rounded text-sm font-mono">
                            {alert.plate || "N/A"}
                        </span>
                    </div>
                </div>
                {alert.repeatOffender && (
                    <div>
                        <Text as="h3">Repeat Offender</Text>
                        <div className="w-fit mt-1 py-2 px-4 flex justify-center rounded-md text-sm bg-red-100 text-red-700">
                            Yes
                        </div>
                    </div>
                )}
            </div>

            {/* Personal Details */}
            <div className="mt-6">
                <Text as="h3">Personal Details</Text>
                <div className="grid grid-cols-3 gap-x-6 gap-y-3 mt-3">
                    <div>
                        <p className="text-xs text-gray-400">Cardholder Name</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.cardholderName || "—"}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Cardholder ID</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.cardholderID || "—"}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Gallagher ID</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.tenantID || "—"}</p>
                    </div>
                </div>
            </div>

            {/* Camera Details */}
            <div className="mt-6">
                <Text as="h3">Camera Details</Text>
                <div className="grid grid-cols-3 gap-x-6 gap-y-3 mt-3">
                    <div>
                        <p className="text-xs text-gray-400">Camera Name</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.cameraName || "—"}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Camera ID</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.cameraID || "—"}</p>
                    </div>
                    <div>
                        <p className="text-xs text-gray-400">Location</p>
                        <p className="text-sm font-medium text-gray-800 mt-0.5">{alert.location || "—"}</p>
                    </div>
                </div>
            </div>

            {/* Alert Description */}
            {alert.description && (
                <div className="mt-6">
                    <Text as="h3">Alert Description</Text>
                    <div className="mt-2 bg-gray-50 border border-gray-100 rounded-lg p-3">
                        <p className="text-sm text-gray-600 whitespace-normal">{alert.description}</p>
                    </div>
                </div>
            )}
        </div>
    );
};
